import {copyCurrentUrlToClipboard, copyToClipboard} from "./functions";

require('./bootstrap');

import Swiper from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
// import 'swiper/css/pagination';
window.Swiper = Swiper;

import Dropzone from "dropzone";
window.Dropzone = Dropzone;

import RangeSlider from "rangeslider.js";
window.RangeSlider = RangeSlider;

import axios from 'axios';

//Range slider
let sliders = $('input[type=range]').rangeslider({
    polyfill: false
});

$( document ).ready(function() {
    let changing = false;
    //Bind input to slider
    $('input[type=range]').each(function () {
        let rangeInput = $(this);
        let inputName = $(this).data('slider-input');
        let inputToBind = $('input[name="' + inputName + '"]');

        rangeInput.val(inputToBind.val()).change();
        inputToBind.on('change', function(e) {
            if (changing) {
                return;
            }
            changing = true;

            rangeInput.val(e.currentTarget.value).change();

            setTimeout(()=> {changing = false}, 1);
        });
    });

    //Bind slider to input
    $(document).on('input', 'input[type="range"]', function(e) {
        if (changing) {
            return;
        }
        changing = true;

        let inputName = $(this).data('slider-input');
        $(`input[name=${inputName}]`).val(e.currentTarget.value)

        setTimeout(()=> {changing = false}, 0);
    });
});

function clamp (number, min, max) {
    return Math.max(min, Math.min(number, max));
}

window.clamp = clamp;

$( document ).ready(function() {
    let messageContainer = $(`[data-floating-error-container]`);

    function showMessage(message, type='alert-success') {
        if (type === 'error') {
            type = 'alert-danger';
        }

        let markup = `<div class="alert ${type} col-12 col-md-6 text-center justify-content-between align-items-center fade show m-0 slide-from-left" style="display: flex; border-radius: 50px; padding: 7px 10px">
            <button type="button" class="btn-close position-static opacity-0 pe-none" data-bs-dismiss="alert" aria-label="Close"></button>
            <div>${message}</div>
            <button type="button" class="btn btn-clear position-static pe-2 py-0 d-flex" style="scale: 1.2;opacity: .6; color: var(--bs-btn-hover-color);" data-bs-dismiss="alert" aria-label="Close">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>`;

        let el = $(markup);
        messageContainer.append(el);

        setTimeout(() => {
            el.fadeOut(1000);
        }, 5000)
    }

    window.printMessage = showMessage;
});

$( document ).ready(function() {
    $(`[type=number], [type=phone]`).each(function () {
        let value = $(this).val();
        let number = Number.parseFloat(value);
        $(this).data('old-value', isNaN(number) ? '' : number);
    });

    $(`[type=number]`).on('input', function (asd = this.value) {
        let value = $(this).val();
        let number = Number.parseFloat(value);
        if (value == number || value.length === 0) {
            $(this).data('old-value', value);
            return;
        }

        $(this).val($(this).data('old-value'));
        console.log('forcing type=number');
    })

    // $(`[type=phone]`).each(function () {
    //     let value = $(this).val();
    //     let number = Number.parseFloat(value);
    //     $(this).data('old-value', isNaN(number) ? '' : number);
    // });

    $(`[type=phone]`).on('input', function (asd = this.value) {
        let value = $(this).val();

        if (value.length > 8) {
            value = value.slice(0, 8);
            $(this).val(value);
        }

        let number = Number.parseFloat(value);
        if (value == number || value.length === 0) {
            $(this).data('old-value', value);
            return;
        }

        $(this).val($(this).data('old-value'));
        console.log('forcing type=phone');
    })
});


//--------CONTENT FADE IN--------------------
// $( document ).ready(function() {
//     const observer = new IntersectionObserver(entries => {
//         entries.forEach(entry => {
//             if (entry.isIntersecting) {
//                 $(entry.target).addClass('content-fade-in-visible');
//             }
//         });
//     });
//
//     $(`.content-fade-in`).each(function () {
//         observer.observe($(this).get(0));
//     });
//
//     $(window).scroll(function() {
//         var targetClass = '.content-fade-in-visible';
//         var windowHeight = $(window).height()*1.3;
//         var scrollTop = $(window).scrollTop();
//
//         $(targetClass).each(function() {
//             var elementOffset = $(this).offset().top;
//             var elementHeight = $(this).outerHeight();
//
//             if (elementOffset + elementHeight < scrollTop || elementOffset > scrollTop + windowHeight) {
//                 $(this).removeClass('content-fade-in-visible');
//             }
//         });
//     });
// });
//--------CONTENT FADE IN END--------------------


// import Alpine from 'alpinejs';
// window.Alpine = Alpine;
//
// $( document ).ready(function() {
//     if (window.Livewire) {
//         window.Livewire.start();
//     }
//     Alpine.start();
// });

window.copyToClipboard = copyToClipboard;
